import { atom, useSetAtom } from 'jotai';
import _ from 'lodash';
import { useEffect, useMemo } from 'react';
import { useSessionInfoContext } from './use-session-info-context';
const A11Y_DEBUG_KEY = '# [A11Y_DEBUG]:';
const debugWatchAtom = atom(false);
const duplexerRequestsAtom = atom([]);
const analyzeResponsesAtom = atom([]);
const addDuplexerRequestAtom = atom(null, (get, set, request) => {
  const duplexerRequests = get(duplexerRequestsAtom);
  if (get(debugWatchAtom)) {
    console.info(`${A11Y_DEBUG_KEY} duplexer request received`, request);
  }
  set(duplexerRequestsAtom, [...duplexerRequests, request]);
});
const addAnalyzeResponseAtom = atom(null, (get, set, request) => {
  const analyzeResponses = get(analyzeResponsesAtom);
  if (get(debugWatchAtom)) {
    console.info(`${A11Y_DEBUG_KEY} analyze response`, request);
  }
  set(analyzeResponsesAtom, [...analyzeResponses, request]);
});
const logDuplexerRequestsAtom = atom(null, get => {
  const events = get(duplexerRequestsAtom);
  const uniqEvents = _.uniqWith(events, _.isEqual);
  const eventsByJobId = _.groupBy(uniqEvents, request => {
    var _request$payload;
    return (_request$payload = request.payload) == null ? void 0 : _request$payload.analysisJobId;
  });
  console.info(`${A11Y_DEBUG_KEY} duplexer events:`);
  console.info(eventsByJobId);
});
const logAnalyzeResponsesAtom = atom(null, get => {
  const analyzeResponses = get(analyzeResponsesAtom);
  console.info(`${A11Y_DEBUG_KEY} analyze responses:`);
  console.info(analyzeResponses);
});
const logLastAnalyzeResponseAtom = atom(null, get => {
  const analyzeResponses = get(analyzeResponsesAtom);
  console.info(`${A11Y_DEBUG_KEY} last analyze response:`);
  console.info(analyzeResponses[analyzeResponses.length - 1]);
});
const toggleWatchModeAtom = atom(false, (get, set) => {
  set(debugWatchAtom, !get(debugWatchAtom));
});
export const useA11yDebug = () => {
  const {
    isDebugMode
  } = useSessionInfoContext();
  const addDuplexerRequest = useSetAtom(addDuplexerRequestAtom);
  const addAnalyzeResponse = useSetAtom(addAnalyzeResponseAtom);
  const logDuplexerRequests = useSetAtom(logDuplexerRequestsAtom);
  const logAnalyzeResponses = useSetAtom(logAnalyzeResponsesAtom);
  const logLastAnalyzeResponse = useSetAtom(logLastAnalyzeResponseAtom);
  const toggleWatchMode = useSetAtom(toggleWatchModeAtom);
  useEffect(() => {
    if (!isDebugMode) {
      return;
    }
    window.a11yDebug = {
      logAnalyzeResponses,
      logDuplexerRequests,
      logLastAnalyzeResponse,
      toggleWatchMode
    };
  }, [isDebugMode, logDuplexerRequests, logAnalyzeResponses, logLastAnalyzeResponse, toggleWatchMode]);
  return useMemo(() => isDebugMode ? {
    addAnalyzeResponse,
    addDuplexerRequest
  } : {}, [isDebugMode, addAnalyzeResponse, addDuplexerRequest]);
};
//# sourceMappingURL=use-a11y-debug.js.map